/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 **/
import { useParams } from 'react-router-dom'

import './Header.css'
import { Link, Actionable, View, Text } from '@az/starc-ui'
import { ChevronLeft } from '@az/starc-ui-icons'
import { useTranslation } from 'react-i18next'
import { clearSession } from '@az/auth-ping'

function Headerbar() {
  const { storeNumber } = useParams()
  const { t } = useTranslation()

  return (
    <div className="header-container">
      <div data-testid="text">
        <Link
          attributes={{ id: 'inventory-link' }}
          href="/"
          variant="plain"
          startIcon={storeNumber ? ChevronLeft : undefined}
        >
          <Text variant="small-body" size="150">
            {t('inventory-lookup')}
          </Text>
        </Link>
      </div>
      <span className="divider"></span>
      <div>
        {storeNumber && (
          <Text variant="small-body" size="150">
            {t('store')}: {storeNumber}
          </Text>
        )}
      </div>
      <div className="header-right">
        <View direction="row" justify="end" align="center" gap={4}>
          <View.Item>
            <Actionable
              fullWidth
              onClick={() => {
                clearSession()
              }}
            >
              <Text variant="small-body" size="150">
                {t('log-out')}
              </Text>
            </Actionable>
          </View.Item>
        </View>
      </div>
    </div>
  )
}
export default Headerbar
